import { gql } from "apollo-boost";

export const GET_STOCKS_OPTION_ITEMS = gql`
  query Query($where: StockOptionWhere!) {
    getStockOptionItems(where: $where)
  }
`;

export const GET_STOCKS_OPTION_ITEMS_TAG_PLUS = gql`
  query Query($where: StockOptionWhere!) {
    getStockOptionItemsTagPlus(where: $where)
  }
`;

export const GET_STOCKS = gql`
  query Data($where: StockWhereInput, $limit: Int, $skip: Int, $orderBy: OrderByInput) {
    stocks(where: $where, limit: $limit, skip: $skip, orderBy: $orderBy) {
      data {
        id
        price
        originPrice
        currency
        size
        amount
        image
        coverImages
        name
        unit
        cfMessage
        isDeleted
        isUsing
        sort
        createdAt
        updatedAt
        note
        barCode
        categoryName
        brandName
        subBrandName
        unitName
        detail
        creationDate
        expirationDate
      }
      total
    }
  }
`;

export const GET_STOCKS_OPTIONS = gql`
  query GetStockOptions($where: StockOptionWhere!, $limit: Int) {
    getStockOptions(where: $where, limit: $limit) 
  }
`;